import { Layout } from "providers/Layout";
import { useLocation } from "react-router-dom";
import {
  BadgeSize,
  ButtonSize,
  BadgeSkeleton,
  ButtonSkeleton,
  TextSkeleton
} from "shared/components";
import { BreadCrumbs } from "shared/components/BreadCrumbs";
import { Card } from "shared/components/Card";

export const LoadingSkeletonSlice = () => {
  const { pathname } = useLocation();

  return (
    <Layout
      header={
        <div>
          <div className="flex items-center justify-between border-b border-alpha-40 px-3 lg:px-6 py-3 lg:flex-nowrap flex-wrap">
            <BreadCrumbs
              crumbs={[
                { title: "Applications", href: "/applications" },
                { title: "", href: pathname }
              ]}
            />

            <div className="flex gap-2">
              <ButtonSkeleton size={ButtonSize.SM} />
              <ButtonSkeleton size={ButtonSize.SM} />
            </div>
          </div>

          <div className="flex items-center justify-between p-3 lg:p-6 flex-wrap lg:flex-nowrap transition-all h-[88px]">
            <TextSkeleton size="xl" className="w-[180px]" />

            <div className="flex gap-2">
              <ButtonSkeleton size={ButtonSize.SM} className="w-[40px]" />
              <ButtonSkeleton size={ButtonSize.SM} />
              <ButtonSkeleton size={ButtonSize.SM} />
            </div>
          </div>
        </div>
      }
    >
      <Card className="h-[179px]">
        <div className="border-b border-alpha-40 px-6 py-4 space-y-2">
          <TextSkeleton size="sm" className="w-[120px]" />
          <TextSkeleton size="base" className="w-[320px]" />
        </div>

        <div className="gap-2 flex p-6">
          <div>
            <TextSkeleton size="xs" className="w-[101px] mb-2" />
            <BadgeSkeleton size={BadgeSize.BASE} className="w-[75px]" />
          </div>
          <div>
            <TextSkeleton size="xs" className="w-[94px] mb-2" />
            <BadgeSkeleton size={BadgeSize.BASE} className="w-[75px]" />
          </div>

          <div>
            <TextSkeleton size="xs" className="w-[80px] mb-2" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
          <div>
            <TextSkeleton size="xs" className="w-[80px] mb-2" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
          <div>
            <TextSkeleton size="xs" className="w-[80px] mb-2" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
          <div>
            <TextSkeleton size="xs" className="w-[80px] mb-2" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
          <div>
            <TextSkeleton size="xs" className="w-[80px] mb-2" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
          <div>
            <TextSkeleton size="xs" className="w-[80px] mb-2" />
            <TextSkeleton size="sm" className="w-[100px]" />
          </div>
        </div>
      </Card>

      <div className="flex gap-4 mt-6">
        <Card className="h-[300px] w-[280px] shrink-0 flex flex-col p-6 justify-center">
          <div className="w-full h-[100px] rounded-lg bg-alpha-40" />

          <ButtonSkeleton size={ButtonSize.SM} className="w-full mt-auto" />
        </Card>
        <Card className="h-[300px] grid grid-cols-4 gap-4 w-full items-center">
          <div className="p-4">
            <TextSkeleton size="sm" className="w-[80px] mb-2" />
            <TextSkeleton size="xl" className="" />
          </div>
          <div className="p-4">
            <TextSkeleton size="sm" className="w-[80px] mb-2" />
            <TextSkeleton size="xl" className="" />
          </div>
          <div className="p-4">
            <TextSkeleton size="sm" className="w-[80px] mb-2" />
            <TextSkeleton size="xl" className="" />
          </div>
          <div className="p-4">
            <TextSkeleton size="sm" className="w-[80px] mb-2" />
            <TextSkeleton size="xl" className="" />
          </div>
          <div className="p-4">
            <TextSkeleton size="sm" className="w-[80px] mb-2" />
            <TextSkeleton size="xl" className="" />
          </div>
          <div className="p-4">
            <TextSkeleton size="sm" className="w-[80px] mb-2" />
            <TextSkeleton size="xl" className="" />
          </div>
          <div className="p-4">
            <TextSkeleton size="sm" className="w-[80px] mb-2" />
            <TextSkeleton size="xl" className="" />
          </div>
          <div className="p-4">
            <TextSkeleton size="sm" className="w-[80px] mb-2" />
            <TextSkeleton size="xl" className="" />
          </div>
        </Card>
      </div>
    </Layout>
  );
};
